import axios from "../api";
import { CRYPTO_TOKEN_SECRET_KEY } from "../config";
import CryptoJS from "crypto-js";
 
const getAuthToken = () => {
    const decryptedData = CryptoJS.AES.decrypt(
        localStorage.getItem("token"),
        CRYPTO_TOKEN_SECRET_KEY
    ).toString(CryptoJS.enc.Utf8);
    return decryptedData;
};

export const allLoginSessionsAction = async (
    startDate,
    endDate,
    perPage,
    page,
    search = ""
) => {
    const authToken = getAuthToken();
    const headers = {
        Authorization: `Bearer ${authToken}`,
    };
    const params = new URLSearchParams({
        startDate,
        endDate,
        perPage,
        page,
    });
    if (search?.trim()) {
        params.set("search", search.trim());
    }
    return new Promise((resolve, reject) => {
        axios
          .get(
            `/api/login-sessions/allLoginSessions?${params.toString()}`,
            {
              headers: headers,
            }
          )
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            reject(error);
          });
    });
};
